import classnames from "classnames";
import * as React from "react";

import LoadingTick from "features/common/components/LoadingTick";
import TextPlaceholder from "features/common/components/TextPlaceholder";
import { Icon } from "features/common/icons";
import LoadingSpinner from "features/common/spinners/LoadingSpinner";

import styles from "./Button.module.scss";
import { Props } from "./types";

export default function Button({
  buttonClassName,
  onClick,
  onPointerDown,
  disabled,
  formType,
  title,
  loading,
  loadingSpinnerColour,
  checked,
  iconLeft,
  iconRight,
  iconClassName,
  textClassName,
  textLoading,
  renderText,
  text,
  emojiClassName,
  Emoji,
  dataTest = "Button",
  ariaLabel,
  id
}: Props) {
  const emoji = Emoji ? <Emoji className={emojiClassName} /> : null;
  return (
    <button
      className={classnames(styles.button, buttonClassName)}
      onClick={onClick}
      onPointerDown={onPointerDown}
      disabled={disabled || loading}
      type={formType as any}
      title={title}
      data-test={dataTest}
      aria-label={ariaLabel}
      id={id}
    >
      <div className={styles.content}>
        {loading && (
          <div className={styles.loading}>
            <LoadingSpinner
              loading={loading}
              colour={loadingSpinnerColour as any}
            />
          </div>
        )}
        {checked && <LoadingTick checked={checked} className={styles.tick} />}
        <div className={styles.iconTextWrapper}>
          {iconLeft && (
            <Icon
              icon={iconLeft}
              className={classnames(iconClassName, styles.icon)}
            />
          )}
          <span className={textClassName}>
            <TextPlaceholder displayInlineBlock loading={textLoading}>
              {renderText ? renderText() : text}
            </TextPlaceholder>
          </span>
          {iconRight && (
            <Icon
              icon={iconRight}
              className={classnames(iconClassName, styles.icon)}
            />
          )}
          {emoji}
        </div>
      </div>
    </button>
  );
}
